import { useContext, useMemo } from 'react';

/**
 * Below follows the trick to allow useId to get ssr-safe ids
 * when apps have wrapped their tree with `SSRProvider`.
 *
 * It's a try-require trick.
 *
 * If react-accessibility-provider is installed by the app,
 * IdContext module is loaded from there.
 * This guarantees that the instance of IdContext will always be the same
 * This guarantees the deterministic sequential orders of autogenerated ids in the app tree
 * npm dedupe bedamned
 *
 * If app is not using react-accessibility-provider,
 * IdContext is loaded from this package's dependency.
 * In that case, autogenerated-ids are random (`uuid`-based)
 * Functionality still works regardless of duplicates in the tree
 * npm dedupe bedamned
 * Note that client hydration will fail because the IDs are random.
 * Apps should ensure that react-accessibility-provider
 * is installed and used so that deterministic IDs can be used.
 */
var IdContextModule;
try {
  // has app installed accessibility-provider as a peer dependency?
  // Yes; load IdContext from its dependencies.
  IdContextModule = require('@nerdwallet/react-accessibility-provider/IdContext'); // eslint-disable-line global-require
} catch (error) {
  if (error.code !== 'MODULE_NOT_FOUND') {
    throw error;
  }
  // fallback to the IdContext from this package's dependency
  IdContextModule = require('@nerdwallet/react-accessibility-id-context'); // eslint-disable-line global-require
}

var _IdContextModule = IdContextModule,
  IdContext = _IdContextModule.default;

/**
 * If a default is not provided, generate an id.
 * This is SSR safe (deterministic id, consistent between server and client)
 * @param defaultId - Default component id.
 */
export default function useId(defaultId) {
  var generateId = useContext(IdContext);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(function () {
    return defaultId || generateId();
  }, [defaultId]);
}